import React from 'react';

const LogoContainer: React.FC<any> = (props) => {
  const { property } = props;

  return (
    <div className="container-cover">
      <div
        style={{
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundImage: `url(${property.logoUrl})`,
          width: 400,
          height: 400,
        }}
      ></div>
    </div>
  );
};

export default LogoContainer;
